import { initContract } from "@ts-rest/core";
import { WorkspaceDetailsDto } from "../dto/workspace/workspace-details.dto";
import { WorkspaceSortValue } from "../types/views/workspaceViews";

const c = initContract();

export const workspacesContract = c.router(
    {
        getWorkspaces: {
            method: "GET",
            path: "/",
            query: c.type<{
                filters?: {
                    search?: string;
                };
                sort?: WorkspaceSortValue;
                page?: number;
                limit?: number;
                organizationId?: string | null;
                excludeUserOrganizations?: boolean;
            }>(),
            responses: {
                200: c.type<{
                    data: WorkspaceDetailsDto[];
                    total: number;
                    page: number;
                    pageCount: number;
                }>(),
            },
        },
    },
    {
        pathPrefix: "/workspaces",
    },
);
